import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ws-period-navigator',
  templateUrl: './ws-period-navigator.component.html',
  styleUrls: ['./ws-period-navigator.component.scss'],
  providers: [DatePipe] // Provide DatePipe
})
export class WsPeriodNavigatorComponent {

  @Input() period: { start: Date, end: Date } = { start: new Date(), end: new Date() };

  @Output() decrementClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() incrementClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(private datePipe: DatePipe) {}
  
  decrementDateClicked(): void {
    this.decrementClicked.emit();
  }

  incrementDateClicked(): void {
    this.incrementClicked.emit();
  }

  formatPeriod(): string {
    if (!this.period) {
      return '';
    }
    const startDate = this.datePipe.transform(this.period.start, 'd MMM');
    const endDate = this.datePipe.transform(this.period.end, 'd MMM');

    if (startDate === endDate) {
      return startDate || '';
    }
    return `${startDate} - ${endDate}`;
  }


}
